// Footer.js
import React from 'react';
import { Grid, Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Nextstep } from './features/counterSlice';



function Footer() {
  const pagestep = useSelector((state) => state.counter.value);
  const dispatch = useDispatch();
  const handleClick = () => {
    // Call the passed function to change the parent's state
    dispatch(Nextstep());
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: 80,
        backgroundColor: "white",
        paddingX: 2,
        boxShadow: 1,
      }}
    >
      <Grid item>
        <Box component="img" src="/images/logo.png" alt="Logo" sx={{ maxHeight: 50 }} />
      </Grid>

      {/* <Grid item>
        {pagestep === 1 || pagestep === 2 || pagestep === 10 ? (
          <Box component="img" src="images/PartnerLogo.png" alt="School Logo" sx={{ maxHeight: 50 }} />
        ) : (
          <Box component="img" onClick={handleClick} src="images/next.png" alt="Next Image" sx={{ maxHeight: 66 }} />
        )}

      </Grid> */}
    </Grid>
  );
}

export default Footer;


